import VerifyPin from './VerifyPin.jsx';

export default VerifyPin;